import oneButton from "../assets/styleImages/1Button.png";
import twoButton from "../assets/styleImages/2Button.png";
import threeButton from "../assets/styleImages/3Buttons.png";
import fourButton from "../assets/styleImages/4Buttons.png";
import oneButtonFastened4 from "../assets/styleImages/1ButtonFastened4.png";
import twoButtonFastened4 from "../assets/styleImages/2ButtonsFastened4.png";
import OneButtonFastened6 from "../assets/styleImages/1ButtonFastened6.png";
import twoButtonsFastened6 from "../assets/styleImages/2ButtonsFastened6.png";
// import Notchedlapelvest from "../assets/styleImages/Notched_lapel.png";
// import Peaklapelvest from "../assets/styleImages/Peak_lapel.png";
// import FishMouth from "../assets/styleImages/FishMouth.png";
 import Shawllapel from "../assets/styleImages/Shaw_lapel.png";
 import Notchedlapel from "../assets/Notched_lapel.png";
 import Peaklapel from "../assets/Peak_lapel.png";
 import FishMouth from "../assets/FishMouth.png";

 import Shawllapelvest from "../assets/VT_ ShawLapel.jpg";
 import Notchedlapelvest from "../assets/VT_NotchedLapelVest.jpg";
 import Peaklapelvest from "../assets/VT_PeakLapel.jpg";
 import FishMouthvest from "../assets/VT_ FishMouth.jpg";
 import PeakLapelOvercoat from "../assets/PeakLapelOvercoat.jpg";
 import ShawlLapelOverCoat from "../assets/ShawlLapelOverCoat.jpg";
 import Vneck3button from "../assets/white_scope_neck_v.png";
 import scoop_neck_u from "../assets/white_scoop_neck_u.png";
 

import Flap from "../assets/styleImages/Flap.png";
import FlapandTicket from "../assets/styleImages/Flap&Ticket.png";
import Flaptwo from "../assets/styleImages/Flap2.png";
import Flapticketwo from "../assets/styleImages/Flap&Ticket2.png";
import Patched from "../assets/styleImages/Patched.png";
import BesomPocket from "../assets/styleImages/BesomPocket.png";
import Normal from "../assets/styleImages/Normal.jpg";
import Patch from "../assets/styleImages/Patch.jpg";
import SideVent from "../assets/styleImages/SideVent.jpg";
import CenterVent from "../assets/styleImages/CenterVent.jpg";
import NoVent from "../assets/styleImages/NoVent.jpg";
import SurgeonCuff from "../assets/styleImages/SurgeonCuff.jpg";
import Kissing from "../assets/styleImages/Kissing.jpg";
import Imitational from "../assets/styleImages/Imitational.jpg";
import TurnbackCuff from "../assets/styleImages/TurnbackCuff.png";
import FullLining from "../assets/styleImages/FullLining.jpg";
import HalfLining from "../assets/styleImages/HalfLining.jpg";
import LiningFinish from "../assets/styleImages/LiningFinish.jpg";
import UnlinedFinish from "../assets/styleImages/UnlinedFinish.jpg";
import None from "../assets/styleImages/none.jpg";
import SinglePleat from "../assets/styleImages/SinglePleat.jpg";
import DoublePleat from "../assets/styleImages/DoublePleat.jpg";
import SingleLoops from "../assets/styleImages/SingleLoops.jpg";
import BuckleSideTabs from "../assets/styleImages/BuckleSideTabs.jpg";
import NoLoops from "../assets/styleImages/NoLoops.jpg";
import ButtonSideTabs from "../assets/styleImages/ButtonSideTabs.jpg";
import SlantPocket from "../assets/styleImages/SlantPocket.jpg";
import StraightPocket from "../assets/styleImages/StraightPocket.jpg";
import JeansPocket from "../assets/styleImages/JeansPocket.jpg";
import JamesBond from "../assets/styleImages/JamesBond.jpg";
import NoBackPockets from "../assets/styleImages/NoBackPockets.png";
import twopipedpockets from "../assets/styleImages/twopipedpockets.png";
import pocketswithbuttons from "../assets/styleImages/2pipedpocketswithbuttons.png";
import twoFlapPockets from "../assets/styleImages/2FlapPockets.png";
import twopatchpockets from "../assets/styleImages/2patchpockets.png";
import Rounded from "../assets/styleImages/Rounded.jpg";
import Chevron from "../assets/styleImages/Chevron.jpg";
import Square from "../assets/styleImages/Square.jpg";
import Hexagon from "../assets/styleImages/Hexagon.jpg";
import Flappockets from "../assets/styleImages/Flap.jpg";
import bib from "../assets/styleImages/bib.jpeg";
import Tuxedo from "../assets/styleImages/Tuxedo.jpg";
import Tuxedos from "../assets/styleImages/Tuxedos.jpg";
import firstButtons from "../assets/styleImages/1Buttons.jpg";
import SecondButtons from "../assets/styleImages/2Buttons.jpg";
import numberOfBackPockets from "../assets/styleImages/2 piped pockets.png";
import ThirdButtons from "../assets/styleImages/3Buttons.jpg";
import YokeNormal from "../assets/styleImages/YokeNormal.jpg";
import YokeSplit from "../assets/styleImages/YokeSplit.jpg";
import YokeCowboy from "../assets/styleImages/YokeCowboy.jpg";
import BottomNormalRounded from "../assets/styleImages/BottomNormalRounded.jpg";
import BottomStraight from "../assets/styleImages/BottomStraight.jpg";
import BottomSideVents from "../assets/styleImages/BottomSideVents.jpg";
import CuffStyleRounded1Button from "../assets/styleImages/CuffStyleRounded1Button.jpg";
import CuffStyleSquare1Button from "../assets/styleImages/CuffStyleSquare1Button.jpg";
import CuffStyleAngle2Button from "../assets/styleImages/CuffStyleAngle2Button.jpg";
import CuffStyleRounded2Button from "../assets/styleImages/CuffStyleRounded2Button.jpg";
import CuffStyleSquare2Button from "../assets/styleImages/CuffStyleSquare2Button.jpg";
import CuffStylePortofino from "../assets/styleImages/CuffStylePortofino.jpg";
import CuffStyleFrenchCuffSquare from "../assets/styleImages/CuffStyleFrenchCuffSquare.jpg";
import CuffStyleFrenchCuffRounded from "../assets/styleImages/CuffStyleFrenchCuffRounded.jpg";
import CuffStyleFrenchVCUT from "../assets/styleImages/CuffStyleFrenchVCUT.jpg";
import CuffStyleFrenchCuffContoured from "../assets/styleImages/CuffStyleFrenchCuffContoured.jpg";
import CuffStyleFrenchCuffAngle from "../assets/styleImages/CuffStyleFrenchCuffAngle.jpg";
import CollarStyleMediumSpread from "../assets/styleImages/CollarStyleMediumSpread.jpg";
import CollarStyleWideSpread from "../assets/styleImages/CollarStyleWideSpread.jpg";
import CollarStyleClassic from "../assets/styleImages/CollarStyleClassic.jpg";
import CollarStyleBluntPoint from "../assets/styleImages/CollarStyleBluntPoint.jpg";
import CollarStyleWingCollar from "../assets/styleImages/CollarStyleWingCollar.jpg";
import CollarStyleMandarinCollar from "../assets/styleImages/CollarStyleMandarinCollar.jpg";
import CollarStyleClubTab from "../assets/styleImages/CollarStyleClubTab.jpg";
import CollarStyleClubCollarandEyelet from "../assets/styleImages/CollarStyleClubCollar&Eyelet.jpg";
import CollarStyleButtonDown from "../assets/styleImages/CollarStyleButtonDown.jpg";
import CollarStyleHiddenButton from "../assets/styleImages/CollarStyleHiddenButton.jpg";

import CollarStayImage from "../assets/styleImages/CollarStay.jpg";



import BackDoubleDarts from "../assets/styleImages/BackDoubleDarts.jpg";
import BackNoPleat from "../assets/styleImages/BackNoPleat.jpg";
import BackBoxPleat from "../assets/styleImages/BackBoxPleat.jpg";
import BackFullBoxPleat from "../assets/styleImages/BackFullBoxPleat.jpg";
import BackSidePleat from "../assets/styleImages/BackSidePleat.jpg";
import CuffNoCuff from "../assets/styleImages/CuffNoCuff.jpg";
import CuffFoldedCuffs from "../assets/styleImages/CuffFoldedCuffs.jpg";
import BandEdgeAngled from "../assets/styleImages/BandEdgeAngled.jpg";
import BandEdgeSquare from "../assets/styleImages/BandEdgeSquare.jpg";
import BandEdgeRound from "../assets/styleImages/BandEdgeRound.jpg";
import BandEdgeVeryExtendedWaistband from "../assets/styleImages/BandEdgeVeryExtendedWaistband.jpg";
import WaistbandWidthWaistbandWidth1 from "../assets/styleImages/WaistbandWidthWaistbandWidth1.jpg";
import WaistbandWidthWaistbandWidth2 from "../assets/styleImages/WaistbandWidthWaistbandWidth2.jpg";
import FlyOptionZip from "../assets/styleImages/FlyOptionZip.jpg";
import FlyOptionButtons from "../assets/styleImages/FlyOptionButtons.jpg";
import PlacketPleatedPlacket from "../assets/styleImages/PlacketPleatedPlacket.jpg";
import PlacketPlainFront from "../assets/styleImages/PlacketPlainFront.jpg";
import PlacketHidden from "../assets/styleImages/PlacketHidden.jpg";
import PlacketTuxedo from "../assets/styleImages/PlacketTuxedo.jpg";
import VestButton4Buttons from "../assets/styleImages/VestButton4Buttons.jpg";
import VestButton5Buttons from "../assets/styleImages/VestButton5Buttons.jpg";
import VestButton6Buttons from "../assets/styleImages/VestButton6Buttons.jpg";
import VestButton1ButtonFastened2 from "../assets/styleImages/VestButton1ButtonFastened2.jpg";
import VestButton1ButtonFastened from "../assets/styleImages/VestButton1ButtonFastened.jpg";
import VestDoubleBreastedsixbuttons from "../assets/styleImages/VestDoubleBreastedsixbuttons.jpg";
import VestDoubleBreasted from "../assets/styleImages/VestDoubleBreasted.jpg";
import VestDoubleBreastedeightbuttons from "../assets/styleImages/VestDoubleBreastedeightbuttons.jpg";
import VestAsymmetric3buttons from "../assets/styleImages/VestAsymmetric3buttons.jpg";
import LapelStyleVT_NoLapel from "../assets/styleImages/LapelStyleVT_NoLapel.jpg";
import LapelStyleVT_NotchedLapel from "../assets/Notched_lapel.png";
import LapelStyleVT_PeakLapel from "../assets/styleImages/Peak_lapel.png";
import LapelStyleVT_ShawLapel from "../assets/styleImages/LapelStyleVT_ ShawLapel.jpg";
import LapelStyleVT_FishMouth from "../assets/styleImages/FishMouth.png";
import ChestPocketWithPocket from "../assets/styleImages/ChestPocketWithPocket.jpg";
import ChestPocketNoPocket from "../assets/styleImages/ChestPocketNoPocket.jpg";
import BottomPocketNoPocket2 from "../assets/styleImages/BottomPocketNoPocket2.jpg";
import BottomPocketRegularPocket from "../assets/styleImages/BottomPocketRegularPocket.jpg";
import BottomPocketFlapsPocket from "../assets/styleImages/BottomPocketFlapsPocket.jpg";
import BottomVT_AngledCut from "../assets/styleImages/BottomVT_AngledCut.jpg";
import BottomVT_Straight from "../assets/styleImages/BottomVT_Straight.jpg";
import OvercoatLapeStyleNarrowLapel from "../assets/styleImages/OvercoatLapeStyleNarrowLapel.jpg";
import OvercoatLapeStyleWideLapel from "../assets/styleImages/OvercoatLapeStyleWideLapel.jpg";
import OvercoatLapeStylePeakLapel from "../assets/styleImages/OvercoatLapeStylePeakLapel.jpg";
import OvercoatLapeStyleShawlLapel from "../assets/styleImages/OvercoatLapeStyleShawlLapel.jpg";
import OvercoatLapeStyleclassic from "../assets/styleImages/OvercoatLapeStyleclassic.jpg";
import OvercoatLapeStyleStandup from "../assets/styleImages/OvercoatLapeStyleStandup.jpg";
import LapelBoutonniereNormal from "../assets/styleImages/LapelBoutonniereNormal.jpg";
import LapelBoutonniereKeyhole from "../assets/styleImages/LapelBoutonniereKeyhole.jpg";
import ChestPocketNormal from "../assets/styleImages/ChestPocketNormal.jpg";
import ChestPocketPatch from "../assets/styleImages/ChestPocketPatch.jpg";
import PocketStyleOvercoatFlapPocket from "../assets/styleImages/PocketStyleOvercoatFlapPocket.jpg";
import PocketStyleOvercoatDoubleWelt2 from "../assets/styleImages/PocketStyleOvercoatDoubleWelt2.jpg";
import PocketStyleOvercoatDiagonal from "../assets/styleImages/PocketStyleOvercoatDiagonal.jpg";
import PocketStyleOvercoatPatch from "../assets/styleImages/PocketStyleOvercoatPatch.jpg";
import PocketStyleOvercoatFlapPocket2 from "../assets/styleImages/PocketStyleOvercoatFlapPocket2.jpg";
import PocketPenPocket from "../assets/styleImages/PocketPenPocket.jpg";
import ElbowPatch from "../assets/styleImages/ElbowPatch.jpg";
import LapelFeltColor from "../assets/styleImages/LapelFeltColor.jpg";
import ShoulderApaulettes from "../assets/styleImages/ShoulderApaulettes.jpg";
import BeltLoose from "../assets/styleImages/Loose.jpg";
import BeltSewed from "../assets/styleImages/Sewed.jpg";

const lapelStyleJacket = {
  "Notched Lapel": {
    key: "notchedLapel",
    img: Notchedlapel,
    label: { en: "Lapel Style", th: "ปก | ปกธรรมดา |" },
    showImage: true,
  },
  "Peak Lapel": {
    key: "peakLapel",
    img: Peaklapel,
    label: { en: "Lapel Style", th: "ปก | ปกแหลม |" },
    showImage: true,
  },
  "Trophy Lapel": {
    key: "trophyLapel",
    // img: FishMouth,
    label: { en: "Lapel Style", th: "ปก | ปกกล้วย ทรอฟฟี่ |" },
    showImage: true,
  },
  "Shawl Lapel": {
    key: "shawlLapel",
    img: Shawllapel,
    label: { en: "Shawl Lapel", th: " ปก | ปกกล้วย |" },
    showImage: true,
  },
  "Fish Mouth": {
    key: "fishMouth",
    img: FishMouth,
    label: { en: "Fish Mouth", th: "ปก | ปกปากปลา |" },
    showImage: true,
  },
};

// Lapel Styles for Vests (usually no lapel or different visuals)
const lapelStyleVest =  {
  "V Neck": {
    key: "vNeck",
    img: LapelStyleVT_NoLapel,
    label: { en: "Lapel Style", th: "ปก | คอ-V |" },
    showImage: true,
  },
  "Notched Lapel": {
    key: "notchedLapel",
    img: Notchedlapelvest,
    label: { en: "Lapel Style", th: "ปก | ปกธรรมดา |" },
    showImage: true,
  },
  "Peak Lapel": {
    key: "peakLapel",
    img: Peaklapelvest,
    label: { en: "Lapel Style", th: "ปก | ปกแหลม |" },
    showImage: true,
  },
  "Shawl Lapel": {
    key: "shawlLapel",
    img: Shawllapelvest,
    //  img: Shawllapelvest,
    label: { en: "Lapel Style", th: "ปก | ปกกล้วย |" },
    showImage: true,
  },
  // "Fish Mouth": {
  //       key: "FishMouth",
  //       img: FishMouth,
  //       label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
  //       showImage: true,
  //     },
  "Trophy Lapel": {
    key: "trophyLapel",
     img: FishMouthvest,
    label: { en: "Lapel Style", th: "ปก | ปกกล้วย ทรอฟฟี่ |" },
    showImage: true,
  },
  
};

// Lapel Styles for Overcoats (usually wider or heavier)
const lapelStyleOvercoat = {
  // "V Neck": {
  //   key: "vNeck",
  //   img: LapelStyleVT_NoLapel,
  //   label: { en: "Lapel Style", th: "คอวี" },
  //   showImage: true,
  // },
  // "Notched Lapel": {
  //   key: "notchedLapel",
  //   img: LapelStyleVT_NotchedLapel,
  //   label: { en: "Lapel Style", th: "ปกเสื้อแบบ Notched" },
  //   showImage: true,
  // },
  "Peak Lapel": {
    key: "peakLapel",
    img: PeakLapelOvercoat,
    label: { en: "Lapel Style", th: "ปก | ปกแหลม |" },
    showImage: true,
  },
  "Shawl Lapel": {
    key: "shawlLapel",
    // img: LapelStyleVT_ShawLapel,
     img: ShawlLapelOverCoat,
    label: { en: "Lapel Style", th: "ปก | ปกกล้วย |" },
    showImage: true,
  },
  // "Fish Mouth": {
  //       key: "FishMouth",
  //       img: FishMouth,
  //       label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
  //       showImage: true,
  //     },
  // "Trophy Lapel": {
  //   key: "trophyLapel",
  //   // img: LapelStyleVT_FishMouth,
  //   label: { en: "Lapel Style", th: "ปกเสื้อแบบ Trophy" },
  //   showImage: true,
  // },
  "Narrow Lapel": {
    key: "narrowLapel",
    img: OvercoatLapeStyleNarrowLapel,
    label: { en: "Lapel Style", th: "ปก | ปกบาง |" },
    showImage: true,
  },
  "Wide Lapel": {
    key: "wideLapel",
    img: OvercoatLapeStyleWideLapel,
    label: { en: "Lapel Style", th: "ปก | ปกหนา |" },
    showImage: true,
  },
   Classic: {
    key: "classic",
    img: OvercoatLapeStyleclassic,
    label: { en: "Lapel Style", th: "ปก | ปกตั้ง |" },
    showImage: true,
  },
  "Stand up": {
    key: "standUp",
    img: OvercoatLapeStyleStandup,
    label: { en: "Lapel Style", th: "ปก | คอจีน |" },
    showImage: true,
  },
};


const productStyleAttributes = (styleName ,productType) => {
 
  const styles = {

  lapelStyle: (() => {
      if (productType === "Vest") return lapelStyleVest;
      if (productType === "Overcoat") return lapelStyleOvercoat;
      if (productType === "Jacket") return lapelStyleJacket;
      if (productType === "Tuxedo ") return lapelStyleJacket;
      return lapelStyleJacket; // Default to Jacket
    })(),





    jacketStyle: {
      "Single Breasted": {
        key: "singleBreasted",
        img: oneButton,
        label: { en: "Jacket Style", th: "ดุม 1 แถว" },
        showImage: false,
      },
      "Double Breasted": {
        key: "doubleBreasted",
        img: twoButton,
        label: { en: "Jacket Style", th: "สไตล์แจ็คเก็ต" },
        showImage: false,
      },
    },

    jacket_style: {
      "Single Breasted": {
        key: "singleBreasted",
        img: oneButton,
        label: { en: "Jacket Style", th: "ดุม 1 แถว" },
        showImage: false,
      },
      "Double Breasted": {
        key: "doubleBreasted",
        img: twoButton,
        label: { en: "Jacket Style", th: "ดุม 2 แถว" },
        showImage: false,
      },
    },

    vestStyle: {
      "Single Breasted": {
        key: "singleBreasted",
        img: oneButton,
        label: { en: "Vest Style", th: "ดุม 1 แถว" },
        showImage: false,
      },
      "Double Breasted": {
        key: "doubleBreasted",
        img: twoButton,
        label: { en: "Vest Style", th: "ดุม 2 แถว" },
        showImage: false,
      },
    },

    stinStyle: {
      "Full Statin": {
        key: "singleBreasted",
        label: { en: "Satin Style", th: "สไตล์ผ้าซาติน" },
        showImage: false,
      },
      "Top Collar Satin only": {
        key: "doubleBreasted",
        label: { en: "Satin Style", th: "สไตล์ผ้าซาติน" },
        showImage: false,
      },
      "Bottom Lapel Satin Only": {
        key: "doubleBreasted",
        label: { en: "Satin Style", th: "สไตล์ผ้าซาติน" },
        showImage: false,
      },
      "Satin Piping on Lapel & Collar": {
        key: "doubleBreasted",
        label: { en: "Satin Style", th: "สไตล์ผ้าซาติน" },
        showImage: false,
      },
    },

    suitButtons: {
      label: { en: "Suit Buttons", th: "กระดุมสูท" },
    },

    fit: {
      label: { en: "Fit", th: "ความพอดี" },
    },

    pickEdgeStitching: {
      label: { en: "Pick Edge Stitching", th: "ดำน้ำ" },
    },

    sleeveButton: {
      "1 Button": {
        label: { en: "Sleeve Button", th: "แขนดุม | 1ดุม |" },
        showImage: false,
      },
      "2 Button": {
        label: { en: "Sleeve Button", th: "แขนดุม | 2ดุม |" },
        showImage: false,
      },
      "3 Button": {
        label: { en: "Sleeve Button", th: "แขนดุม | 3ดุม |" },
        showImage: false,
      },
      "4 Button": {
        label: { en: "Sleeve Button", th: "แขนดุม | 4ดุม |" },
        showImage: false,
      },
      "5 Button": {
        label: { en: "Sleeve Button", th: "แขนดุม | 5ดุม |" },
        showImage: false,
      },

       "1": {
        label: { en: "Sleeve Button", th: "แขนดุม | 1ดุม |" },
        showImage: false,
      },
      "2": {
        label: { en: "Sleeve Button", th: "แขนดุม | 2ดุม |" },
        showImage: false,
      },
      "3": {
        label: { en: "Sleeve Button", th: "แขนดุม | 3ดุม |" },
        showImage: false,
      },
      "4": {
        label: { en: "Sleeve Button", th: "แขนดุม | 4ดุม |" },
        showImage: false,
      },
      "5": {
        label: { en: "Sleeve Button", th: "แขนดุม | 5ดุม |" },
        showImage: false,
      },
    },

    lapelwidth: {
      "2.75'": {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก2.75''" },
        showImage: false,
      },
      "2.5'": {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก2.5''" },
        showImage: false,
      },
      "2.25'": {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก2.25''" },
        showImage: false,
      },
      "3'": {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก3''" },
        showImage: false,
      },
      "3.25'": {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก3.25''" },
        showImage: false,
      },
      "3.5'": {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก3.5''" },
        showImage: false,
      },
      "3.75'": {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก3.75''" },
        showImage: false,
      },
      "4'": {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก4''" },
        showImage: false,
      },
       '2.75" ': {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก2.75''" },
        showImage: false,
      },
      '2.5" ': {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก2.5''" },
        showImage: false,
      },
      '2.25"': {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก2.25''" },
        showImage: false,
      },
      '3"': {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก3''" },
        showImage: false,
      },
      '3.25"': {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก3.25''" },
        showImage: false,
      },
      '3.5"': {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก3.5''" },
        showImage: false,
      },
      '3.75"': {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก3.75''" },
        showImage: false,
      },
      '4"': {
        label: { en: "Lapel Width", th: "ปกกว้าง | ปก4''" },
        showImage: false,
      },
    },
    elBowPatch: {
      yes : {
      label: { en: "Elbow Patch", th: "แพทช์ข้อศอก - ใช่ |" },
      img:ElbowPatch,
      showImage: true,
      },
      No : {
      label: { en: "Elbow Patch", th: "แผ่นแปะข้อศอก - ไม่มี |" },
      img:ElbowPatch,
      showImage: true,
      },
     
    },
    btnStyle: {
      "1 Button": {
        key: "1btn",
        img: oneButton,
        label: { en: "Button Style", th: "1 แถว 1 ดุม |" },
        showImage: true,
      },
      "2 Button": {
        key: "2btn",
        img: twoButton,
        label: { en: "Button Style", th: "1 แถว 2 ดุม |" },
        showImage: true,
      },
      "3 Button": {
        key: "3btn",
        img: threeButton,
        label: { en: "Button Style", th: "1 แถว 3 ดุม |" },
        showImage: true,
      },
      "4 Button": {
        key: "4btn",
        img: fourButton,
        label: { en: "Button Style", th: "1 แถว 4 ดุม |" },
        showImage: true,
      },
      "V Neck 4 Button": {
        key: "VNeck4Button",
        img: VestButton4Buttons,
        label: { en: "Button Style", th: "4 ดุม |" },
        showImage: true,
      },
      "V Neck 5 Button": {
        key: "Vneck5Button",
        img: VestButton5Buttons,
        label: { en: "Button Style", th: " 5 ดุม |" },
        showImage: true,
      },
      "V Neck 6 Button": {
        key: "Vneck6Button",
        img: VestButton6Buttons,
        label: { en: "Button Style", th: "6 ดุม |" },
        showImage: true,
      },
      "Scooped V as IG 4 Button": {
        key: "ScoopedVIG4Button",
        img: VestButton1ButtonFastened2,
        label: { en: "Button Style", th: " 2 แถวติด 2 ดุม |" },
        showImage: true,
      },
      "Scoop Neck 3 Button": {
        key: "ScoopNeck3Button",
        img: scoop_neck_u,
        label: { en: "Button Style", th: "2 แถวติด 1 ดุม |" },
        showImage: true,
      },
      "V Neck 3 Button": {
        key: "Vneck3Button",
        img: Vneck3button,
        label: { en: "Button Style", th: "3 ดุม |" },
        showImage: true,
      },
      "4 BUTTON 1 FASTNER": {
        key: "4btn4fast1",
        img: oneButtonFastened4,
        label: { en: "Button Style", th: "2 แถว 4 ดุม 1 ดุมจริง |" },
        showImage: true,
      },
      "4 BUTTON 2 FASTNER": {
        key: "4btn4fast2",
        img: twoButtonFastened4,
        label: { en: "Button Style", th: "2 แถว 4 ดุม 2 ดุมจริง |" },
        showImage: true,
      },
      "6 BUTTON 1 FASTNER": {
        key: "6btn4fast1",
        img: OneButtonFastened6,
        label: { en: "Button Style", th: "2 แถว 6 ดุม 1 ดุมจริง |" },
        showImage: true,
      },
      "6 BUTTON 2 FASTNER": {
        key: "6btn4fast2",
        img: twoButtonsFastened6,
        label: { en: "Button Style", th: "2 แถว 6 ดุม 2 ดุมจริง |" },
        showImage: true,
      },
      "V Neck DB 6 Button": {
    key: "Vneck6Button",
    img: VestDoubleBreastedsixbuttons,
    label: { en: "Button Style", th: "6 ดุม |" },
    showImage: true,
  },
  "V Neck DB 4 Buttons": {
    key: "VNeckDBFourButtons",
    img: VestDoubleBreasted,
    label: { en: "Button Style", th: "2 แถวติด 2 ดุม |" },
    showImage: true,
  },
  "V Neck DB 8 Buttons": {
    key: "VNeckDBEightButtons",
    img: VestDoubleBreastedeightbuttons,
    label: { en: "Button Style", th: "เสื้อเชิ้ตคอวี 8 กระดุม |" },
    showImage: true,
  },
  "V Neck Asymmetric 3 Button": {
    key: "VNeckAsymmetricThreeButton",
    img: VestAsymmetric3buttons,
    label: { en: "Button Style", th: "2 แถวติด 1 ดุม |" },
    showImage: true,
  },
    },

    btnStyleMultiple: {
      "4 BUTTON 1 FASTNER": {
        key: "4btn4fast1",
        img: oneButtonFastened4,
        label: { en: "Button Style", th: "2 แถว 4 ดุม 1 ดุมจริง |" },
        showImage: true,
      },
      "4 BUTTON 2 FASTNER": {
        key: "4btn4fast2",
        img: twoButtonFastened4,
        label: { en: "Button Style", th: "2 แถว 4 ดุม 2 ดุมจริง |" },
        showImage: true,
      },
      "6 BUTTON 1 FASTNER": {
        key: "6btn4fast1",
        img: OneButtonFastened6,
        label: { en: "Button Style", th: "2 แถว 6 ดุม 1 ดุมจริง |" },
        showImage: true,
      },
      "6 BUTTON 2 FASTNER": {
        key: "6btn4fast2",
        img: twoButtonsFastened6,
        label: { en: "Button Style", th: "2 แถว 6 ดุม 2 ดุมจริง" },
        showImage: true,
      },

      "2 Button": {
        key: "2btn",
        label: { en: "Button Style", th: "1 แถว 2 ดุม |" },
        
      },
      "3 Button": {
        key: "3btn",
        label: { en: "Button Style", th: "1 แถว 3 ดุม |" },
      },
      "4 Button": {
        key: "4btn",
        label: { en: "Button Style", th: "1 แถว 4 ดุม |" },
      },

    },

    // lapelStyle: {
    //   "Notched Lapel": {
    //     key: "notchedLapel",
    //     img: Notchedlapel,
    //     label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
    //     showImage: true,
    //   },
    //   "Peak Lapel": {
    //     key: "peakLapel",
    //     img: Peaklapel,
    //     label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
    //     showImage: true,
    //   },
    //   "Shawl Lapel": {
    //     key: "shawlLapel",
    //     img: "/assets/images/products/All/LapelStyle/Shawl_lapel.png",
    //     label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
    //     showImage: false,
    //   },
    //   "Fish Mouth": {
    //     key: "FishMouth",
    //     img: FishMouth,
    //     label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
    //     showImage: true,
    //   },
    //   "V Neck": {
    //     label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
    //     showImage: false,
    //   },
    //   "Trophy Lapel": {
    //     label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
    //     showImage: false,
    //   },
    //   "Narrow Lapel": {
    //     label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
    //     showImage: false,
    //   },
    //   Classic: {
    //     label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
    //     showImage: false,
    //   },
    //   "Stand up": {
    //     label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
    //     showImage: false,
    //   },
    //   "Wide Lapel": {
    //     label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
    //     showImage: false,
    //   },
    // },
    hipPocket: {
      Straight: {
        key: "straight",
        img: Flap,
        label: { en: "Hip Pocket", th: "กระเป๋าตรง |" },
        showImage: true,
      },
      "Straight & Ticket": {
        key: "straightTicket",
        img: FlapandTicket,
        label: { en: "Hip Pocket", th: "กระเป๋าตรง / เป๋า 2 ใบ |" },
        showImage: true,
      },
      Slant: {
        key: "slant",
        img: Flaptwo,
        label: { en: "Hip Pocket", th: "กระเป๋าเฉียง |" },
        showImage: true,
      },
      "Slant & Ticket": {
        key: "slantTicket",
        img: Flapticketwo,
        label: { en: "Hip Pocket", th: " กระเป๋าเฉียง / เป๋า 2 ใบ |" },
        showImage: true,
      },
      Patched: {
        key: "patched",
        img: PocketStyleOvercoatPatch,
        label: { en: "Hip Pocket", th: "เป๋าประ |" },
        showImage: true,
      },
      Besom: {
        key: "besom",
        img: BesomPocket,
        label: { en: "Hip Pocket", th: "เป๋าริม บน-ล่าง |" },
        showImage: true,
      },
      "Flap Pocket": {
        key: "flapPocket",
        img: PocketStyleOvercoatFlapPocket,
        label: { en: "Hip Pocket", th: "กระเป๋ามีฝา |" },
        showImage: true,
      },
      "Double Welt": {
        key: "doubleWelt",
        img: PocketStyleOvercoatDoubleWelt2,
        label: { en: "Hip Pocket", th: "กระเป๋าสะโพก |" },
        showImage: true,
      },
      Diagonal: {
        key: "diagonal",
        img: PocketStyleOvercoatDiagonal,
        label: { en: "Hip Pocket", th: "กระเป๋าสะโพก |" },
        showImage: true,
      },
      "Flap Pocket with Ticket": {
        key: "flapwithTicket",
        img: PocketStyleOvercoatFlapPocket2,
        label: { en: "Hip Pocket", th: "กระเป๋ามีฝา |" },
        showImage: true,
      },
      "Double Welt With Ticket": {
        key: "doubleWeltWithTicket",
        img: PocketStyleOvercoatDoubleWelt2,
        label: { en: "Hip Pocket", th: "กระเป๋าสะโพก |" },
        showImage: true,
      },
    },

    chestPocket: {
      Normal: {
        key: "normal",
        img: ChestPocketNormal,
        label: { en: "Chest Pocket", th: "กระเป๋าหน้าอก | รังธรรมดา" },
        showImage: true,
      },
      Patch: {
        key: "patch",
        img: Patch,
        label: { en: "Chest Pocket", th: "กระเป๋าหน้าอก | เป๋าประ" },
        showImage: true,
      },
      None: {
        key: "none",
        label: { en: "Chest Pocket", th: "กระเป๋าหน้าอก | ไม่มี" },
        showImage: false,
      },
      "Left Top Pocket": {
        key: "leftTopPocket",
        img: ChestPocketWithPocket,
        label: { en: "Chest Pocket", th: " กระเป๋าหน้าอก | มีกระเป๋า |" },
        showImage: true,
      },
      "No Top Pocket": {
        key: "noTopPocket",
        img: ChestPocketNoPocket,
        label: { en: "Chest Pocket", th: "กระเป๋าหน้าอก | ไม่มีกระเป๋า |" },
        showImage: true,
      },
    },

    vent: {
      'Side Vent': {
        key: "sideVent",
        img: SideVent,
        label: { en: "Vent", th: "ผ่าหลัง | ผ่าข้าง |" },
        showImage: true,
      },
      'Center Vent': {
        key: "centerVent",
        img: CenterVent,
        label: { en: "Vent", th: "ผ่าหลัง |ผ่ากลาง |" },
        showImage: true,
      },
      'No Vent': {
        key: "noVent",
        img: NoVent,
        label: { en: "Vent", th: "ผ่าหลัง |ไม่ผ่า |" },
        showImage: true,
      },
      'Double': {
        key: "sideVent",
        img: SideVent,
        label: { en: "Vent", th: "ผ่าข้าง" },
        showImage: true,
      },
      'Single': {
        key: "centerVent",
        img: CenterVent,
        label: { en: "Vent", th: "ผ่ากลาง" },
        showImage: true,
      },
      'None': {
        key: "noVent",
        img: NoVent,
        label: { en: "Vent", th: "ไม่ผ่า" },
        showImage: true,
      },
    },

    sleeveButtonType: {
      Surgeon: {
        key: "surgeon",
        img: SurgeonCuff,
        label: { en: "Sleeve Button Type", th: "รางดุมแขน |  รังจริง |" },
        showImage: true,
      },
      Kissing: {
        key: "kissing",
        img: Kissing,
        label: { en: "Sleeve Button Type", th: "รางดุมแขน |  ดุมซ้อน |" },
        showImage: true,
      },
      Imitation: {
        key: "imitation",
        img: Imitational,
        label: { en: "Sleeve Button Type", th: "รางดุมแขน | รางดุมหลอก |" },
        showImage: true,
      },
      Turnback: {
        key: "turnback",
        img: TurnbackCuff,
        label: { en: "Sleeve Button Type", th: "รางดุมแขน | แขนเบิ้ล |" },
        showImage: true,
      },
    },
    sleeveButtonholeThread: {
      label: { en: "Sleeve Buttonhole Thread", th: "รางดุมแขนสี" },
    },

    sleeveBtnHoleColor : {
       label: { en: "Sleeve Buttonhole Thread", th: "รางดุมแขนสี" },
    },

    collorFelt: {
      label: { en: "Collar Felt", th: "สักหลาดคอ" },
    },

    Lining: {
      "Fully Lined": {
        key: "fullyLined",
        img: FullLining,
        label: { en: "Lining", th: "ซับใน | ซับในเต็ม |" },
        showImage: true,
      },
      "Half Lining": {
        key: "halfLining",
        img: HalfLining,
        label: { en: "Lining", th: "ซับใน | ซับในครึ่ง |" },
        showImage: true,
      },
      "Quarter Lining": {
        key: "quarterLining",
        img: LiningFinish,
        label: { en: "Lining", th: "ซับใน | ซับใน 1/4 |" },
        showImage: true,
      },
      "No Lining": {
        key: "noLining",
        img: UnlinedFinish,
        label: { en: "Lining", th: " ซับใน | ไม่มีซับใน |" },
        showImage: true,
      },
    },

    frontPleat: {
      None: {
        key: "none",
        img: None,
        label: { en: "Front Pleat", th: "จีบหน้า | ไม่มีจีบ |" },
        showImage: true,
      },
      Single: {
        key: "single",
        img: SinglePleat,
        label: { en: "Front Pleat", th: "จีบหน้า | 1จีบ |" },
        showImage: true,
      },
      Double: {
        key: "double",
        img: DoublePleat,
        label: { en: "Front Pleat", th: "จีบหน้า | 2จีบ |" },
        showImage: true,
      },
    },

    monogramTextType: {
      label: { en: "Monogram Text Type", th: "แบบปัก" },
    },

    monogramTextColor: {
      label: { en: "Monogram Text Color", th: "ปักสี" },
    },

    monogramText: {
      label: { en: "Monogram Text", th: "ปักชื่อ" },
    },

    monogramText1: {
      label: { en: "Monogram Text-1", th: "ข้อความโมโนแกรม-1" },
    },

    monogramText2: {
      label: { en: "Monogram Text-2", th: "ข้อความโมโนแกรม-2" },
    },

    waistbandStyle: {
      "Belt Loops": {
        key: "beltLoops",
        img: SingleLoops,
        label: { en: "Waistband Style", th: "สไตล์ขอบเอว" },
        showImage: true,
      },
      "Adjustable Metal Tabs": {
        key: "adjustableMetalTabs",
        img: BuckleSideTabs,
        label: { en: "Waistband Style", th: "สไตล์ขอบเอว" },
        showImage: true,
      },
      "No Belt Loops": {
        key: "noBeltLoops",
        img: NoLoops,
        label: { en: "Waistband Style", th: "สไตล์ขอบเอว" },
        showImage: true,
      },
      "Adjustable Button Tabs": {
        key: "adjustableButtonTabs",
        img: ButtonSideTabs,
        label: { en: "Waistband Style", th: "สไตล์ขอบเอว" },
        showImage: true,
      },
    },

    frontPocket: {
      Slanted: {
        key: "slanted",
        img: SlantPocket,
        label: { en: "Front Pocket", th: " กระเป๋าหน้า | กระเป๋าเฉียง |" },
        showImage: true,
      },
      Straight: {
        key: "straight",
        img: StraightPocket,
        label: { en: "Front Pocket", th: "กระเป๋าหน้า | กระเป๋าตรง |" },
        showImage: true,
      },
      Jeans: {
        key: "jeans",
        img: JeansPocket,
        label: { en: "Front Pocket", th: "กระเป๋าหน้า | กระเป๋ายีนส์ |" },
        showImage: true,
      },
      "James Bond": {
        key: "jamesBond",
        img: JamesBond,
        label: { en: "Front Pocket", th: "กระเป๋าหน้า | กระเป๋าเจมส์บอล |" },
        showImage: true,
      },
    },

    backPocket: {
      "No Back Pockets": {
        key: "noPockets",
        img: NoBackPockets,
        label: { en: "Back Pocket", th: "ไม่มีกระเป๋าหลัง" },
        showImage: true,
      },
      "2 Piped Pockets": {
        key: "2pipedpockets",
        img: twopipedpockets,
        label: { en: "Back Pocket", th: "กระเป๋าหลังแบบขอบสองชั้น" },
        showImage: true,
      },
      "2 Piped Pockets with Buttons": {
        key: "2pipedpocketswithButtons",
        img: pocketswithbuttons,
        label: { en: "Back Pocket", th: "กระเป๋าหลังแบบขอบสองชั้นพร้อมกระดุม" },
        showImage: true,
      },
      "2 Flap Pockets": {
        key: "2FlapPockets",
        img: twoFlapPockets,
        label: { en: "Back Pocket", th: "กระเป๋าหลังแบบฝาพับสองช่อง" },
        showImage: true,
      },
      "2 Patch Pockets": {
        key: "2Patchpockets",
        img: twopatchpockets,
        label: { en: "Back Pocket", th: "เป๋ายีนส์ประ" },
        showImage: true,
      },
    },

    PocketStyle: {
      "Rounded Pocket": {
        key: "RoundedPocket",
        img: Rounded,
        label: { en: "Pocket Style", th: "กระเป๋า | กระเป๋ามน |" },
        showImage: true,
      },
      "Chevron Pocket": {
        key: "ChevronPocket",
        img: Chevron,
        label: { en: "Pocket Style", th: "สไตล์กระเป๋าแบบเชฟรอน" },
        showImage: true,
      },
      "Square Pocket": {
        key: "SquarePocket",
        img: Square,
        label: { en: "Pocket Style", th: "กระเป๋าสี่เหลี่ยม |" },
        showImage: true,
      },
      "Pen Pocket": {
        key: "PenPocket",
        img: PocketPenPocket,
        label: { en: "Pocket Style", th: "กระเป๋าใส่ปากกา" },
        showImage: true,
      },
      "Hexagon Pocket": {
        key: "HexagonPocket",
        img: Hexagon,
        label: { en: "Pocket Style", th: "กระเป๋าหกเหลี่ยม" },
        showImage: true,
      },
      "Flap Pocket": {
        key: "FlapPocket",
        img: Flappockets,
        label: { en: "Pocket Style", th: "กระเป๋าแบบมีฝาพับ" },
        showImage: true,
      },
    },
    Tuxedoshirt: {
      "Shirt With Bib": {
        key: "ShirtWithBib",
        img: bib,
        label: { en: "Tuxedo shirt", th: "ทักซิโด้แปะผ้า |" },
        showImage: true,
      },
      "Shirt with Pleats": {
        key: "ShirtWithPleats",
        img: Tuxedo,
        label: { en: "Tuxedo shirt", th: "ทักซิโด้จีบ |" },
        showImage: true,
      },
      "Shirt with Pleats and Shirt Track": {
        key: "ShirtWithPleatsAndShirtTrack",
        img: Tuxedos,
        label: { en: "Tuxedo shirt", th: "" },
        showImage: true,
      },
    },
    CollarstyleButtonOption: {
      "1 Button": {
        key: "1Button",
        img: firstButtons,
        label: { en: "Collar style Button Option", th: "คอกระดุม1เม็ด |" },
        showImage: true,
      },
      "2 Button": {
        key: "2Button",
        img: SecondButtons,
        label: { en: "Collar style Button Option", th: "คอกระดุม2เม็ด |" },
        showImage: true,
      },
      "3 Button": {
        key: "3Button",
        img: ThirdButtons,
        label: { en: "Collar style Button Option", th: "คอกระดุม3เม็ด |" },
        showImage: true,
      },
    },
    YokeStyle: {
      Normal: {
        key: "Normal",
        img: YokeNormal,
        label: { en: "Yoke Style", th: "รองไหล่ | ธรรมดา|" },
        showImage: true,
      },
      Split: {
        key: "Split",
        img: YokeSplit,
        label: { en: "Yoke Style", th: "รองไหล่ |เฉียงแยก |" },
        showImage: true,
      },
      Cowboy: {
        key: "Cowboy",
        img: YokeCowboy,
        label: { en: "Yoke Style", th: "รองไหล่ | คาวบอย |" },
        showImage: true,
      },
    },

    shirtBottomStyle: {
      "Rounded Bottom": {
        key: "RoundedBottom",
        img: BottomNormalRounded,
        label: { en: "Shirt Bottom Style", th: "ชายเสื้อ | ชายเสื้อมน |" },
        showImage: true,
      },
      "Straight Bottom": {
        key: "StraightBottom",
        img: BottomStraight,
        label: { en: "Shirt Bottom Style", th: "ชายเสื้อ | ชายเสื้อตรง |" },
        showImage: true,
      },
      "Side Vent": {
        key: "SideVent",
        img: BottomSideVents,
        label: { en: "Shirt Bottom Style", th: "ชายเสื้อ | ชายเสื้อตรงมีผ่า |" },
        showImage: true,
      },
    },

    ThreadOnButton: {
      label: { en: "Thread on Button", th: "สีด้ายเย็บดุม" },
    },

    shirtCuffStyle: {
      "One Button Rounded": {
        key: "OneButtonRounded",
        img: CuffStyleRounded1Button,
        label: {
          en: "Shirt Cuff Style",
          th: "1ดุมมน |"
        },
        showImage: true,
      },
      "One Button Straight": {
        key: "OneButtonStraight",
        img: CuffStyleSquare1Button,
        label: {
          en: "Shirt Cuff Style",
          th: "เหลี่ยม 1 ดุม |",
        },
        showImage: true,
      },
      "One Button Angular": {
        key: "OneButtonAngular",
        img: CuffStyleAngle2Button,
        label: {
          en: "Shirt Cuff Style",
          th: "1ดุมตัดมุม |",
        },
        showImage: true,
      },
      "Two Button Rounded": {
        key: "TwoButtonRounded",
        img: CuffStyleRounded2Button,
        label: {
          en: "Shirt Cuff Style",
          th: "2ดุมมน |",
        },
        showImage: true,
      },
      "Two Button Straight": {
        key: "TwoButtonStraight",
        img: CuffStyleSquare2Button,
        label: {
          en: "Shirt Cuff Style",
          th: "เหลี่ยม 2 ดุม |",
        },
        showImage: true,
      },
      "Two Button Angular": {
        key: "TwoButtonAngular",
        img: CuffStyleAngle2Button,
        label: {
          en: "Shirt Cuff Style",
          th: "2ดุมตัดมุม |",
        },
        showImage: true,
      },
      Portofino: {
        key: "Portofino",
        img: CuffStylePortofino,
        label: { en: "Shirt Cuff Style", th: "กล้ามปู 2 ดุม |" },
        showImage: true,
      },
      "French Cuff Straight": {
        key: "FrenchCuffStraight",
        img: CuffStyleFrenchCuffSquare,
        label: { en: "Shirt Cuff Style", th: "เบิ้ลสี่เหลี่ยม |" },
        showImage: true,
      },
      "French Cuff Rounded": {
        key: "FrenchCuffRounded",
        img: CuffStyleFrenchCuffRounded,
        label: { en: "Shirt Cuff Style", th: "เบิ้ลตัดมน |" },
        showImage: true,
      },
      "French Cuff V-CUT": {
        key: "FrenchCuffVCUT",
        img: CuffStyleFrenchVCUT,
        label: { en: "Shirt Cuff Style", th: "เบิ้ลกล้ามปูมน |" },
        showImage: true,
      },
      "French Cuff Contoured": {
        key: "FrenchCuffContoured",
        img: CuffStyleFrenchCuffContoured,
        label: { en: "Shirt Cuff Style", th: "เบิ้ลตัดโค้ง |" },
        showImage: true,
      },
      "French Cuff Angular": {
        key: "FrenchCuffAngular",
        img: CuffStyleFrenchCuffAngle,
        label: { en: "Shirt Cuff Style", th: "เบิ้ลตัดมุม |" },
        showImage: true,
      },
    },
    shirtColorStyle: {
  "Medium Spread": {
    key: "MediumSpread",
    img: CollarStyleMediumSpread,
    label: { en: "Shirt Collar Style", th: "ปกป้านนิดหน่อย |" },
    showImage: true,
  },
  "Wide Spread": {
    key: "Widespread",
    img: CollarStyleWideSpread,
    label: { en: "Shirt Collar Style", th: "ป้านธรรมดา |" },
    showImage: true,
  },
  Classic: {
    key: "Classic",
    img: CollarStyleClassic,
    label: { en: "Shirt Collar Style", th: "ปกธรรมดา |" },
    showImage: true,
  },
  "2'Medium Spread": {
    key: "2MediumSpread",
    img: CollarStyleBluntPoint,
    label: { en: "Shirt Collar Style", th: "2 'ปกป้านนิดหน่อย |" },
    showImage: true,
  },
  "Wing Tip": {
    key: "WingTip",
    img: CollarStyleWingCollar,
    label: { en: "Shirt Collar Style", th: "ปกเสื้อปีกนก |" },
    showImage: true,
  },
  Manderine: {
    key: "Mandarin",
    img: CollarStyleMandarinCollar,
    label: { en: "Shirt Collar Style", th: "คอจีน |" },
    showImage: true,
  },
  Tab: {
    key: "Tab",
    img: CollarStyleClubTab,
    label: { en: "Shirt Collar Style", th: "ปกเสื้อแบบแท็บ |" },
    showImage: true,
  },
  Eyelet: {
    key: "Eyelet",
    img: CollarStyleClubCollarandEyelet,
    label: { en: "Shirt Collar Style", th: "ปกติดเหล๊ก |" },
    showImage: true,
  },
  "Button Down": {
    key: "ButtonDown",
    img: CollarStyleButtonDown,
    label: { en: "Shirt Collar Style", th: "ปกติดดุม |" },
    showImage: true,
  },
  "Hidden Button Down": {
    key: "HiddenButtonDown",
    img: CollarStyleHiddenButton,
    label: { en: "Shirt Collar Style", th: "ดุมปกซ่อน |" },
    showImage: true,
  },
},

shirtBackStyle: {
  "Double Darts": {
    key: "doubleDarts",
    img: BackDoubleDarts,
    label: { en: "Shirt Back Style", th: " เกล็ดหลัง |" },
    showImage: true,
  },
  "No Pleat": {
    key: "noPleat",
    img: BackNoPleat,
    label: { en: "Shirt Back Style", th: "ไม่มีจีบ |" },
    showImage: true,
  },
  "Box pleat": {
    key: "boxpleat",
    img: BackBoxPleat,
    label: { en: "Shirt Back Style", th: "จีบกลาง |" },
    showImage: true,
  },
  "Full Box pleat": {
    key: "fullBoxpleat",
    img: BackFullBoxPleat,
    label: { en: "Shirt Back Style", th: " จีบกลางยาว |" },
    showImage: true,
  },
  "Side pleates": {
    key: "sidePleat",
    img: BackSidePleat,
    label: { en: "Shirt Back Style", th: "จีบข้าง |" },
    showImage: true,
  },
},

cuff: {
  None: {
    key: "none",
    img: CuffNoCuff,
    label: { en: "Cuff", th: "ปลายขาธรรมดา" },
    showImage: true,
  },
  Cuffed: {
    key: "cuffed",
    img: CuffFoldedCuffs,
    label: { en: "Cuff", th: "ปลายขาเบิ้ล" },
    showImage: true,
  },
},

   bandEdgeSystem: {
  Angled: {
    key: "angled",
    img: BandEdgeAngled,
    label: { en: "Band Edge System", th: "ขอบเอวแบบเฉียง" },
    showImage: true,
  },
  Square: {
    key: "square",
    img: BandEdgeSquare,
    label: { en: "Band Edge System", th: "ขอบเอวแบบเหลี่ยม" },
    showImage: true,
  },
  Round: {
    key: "round",
    img: BandEdgeRound,
    label: { en: "Band Edge System", th: "ขอบเอวแบบโค้ง" },
    showImage: true,
  },
  "Extended Waistband": {
    key: "extendedWaistband",
    img: BandEdgeVeryExtendedWaistband,
    label: { en: "Band Edge System", th: "ขอบเอวแบบขยาย" },
    showImage: true,
  },
},

waistBandWidth: {
  "1.5' 1 button": {
    key: "1button",
    img: WaistbandWidthWaistbandWidth1,
    label: { en: "Waist Band Width", th: "ความกว้างขอบเอว 1.5 นิ้ว (1 กระดุม)" },
    showImage: true,
  },
  "2.5' 2 button": {
    key: "2button",
    img: WaistbandWidthWaistbandWidth2,
    label: { en: "Waist Band Width", th: "ความกว้างขอบเอว 2.5 นิ้ว (2 กระดุม)" },
    showImage: true,
  },
},

flyOption: {
  Zip: {
    key: "Zip",
    img: FlyOptionZip,
    label: { en: "Fly Option", th: "ซิป" },
    showImage: true,
  },
  Buttons: {
    key: "buttons",
    img: FlyOptionButtons,
    label: { en: "Fly Option", th: "กระดุม" },
    showImage: true,
  },
},

shirtPlacketStyle: {
  "Pleated Placket": {
    key: "pleatedPlacket",
    img: PlacketPleatedPlacket,
    label: { en: "Shirt Placket Style", th: "สาบนอก |" },
    showImage: true,
  },
  "Plain Placket": {
    key: "plainPlacket",
    img: PlacketPlainFront,
    label: { en: "Shirt Placket Style", th: " สาบใน |" },
    showImage: true,
  },
  "Hidden Placket": {
    key: "hiddenPlacket",
    img: PlacketHidden,
    label: { en: "Shirt Placket Style", th: " สาบซ่อน |" },
    showImage: true,
  },
  "Pleated with Shirt Track": {
    key: "pleatedTrack",
    label: { en: "Shirt Placket Style", th: "" },
    showImage: false,
  },
  "Plain with Shirt Track": {
    key: "plainTrack",
    label: { en: "Shirt Placket Style", th: "" },
    showImage: false,
  },
  Tuxedo: {
    key: "tuxedo",
    img: PlacketTuxedo,
    label: { en: "Shirt Placket Style", th: "จีบทักซิโด้" },
    showImage: true,
  },
},

ButtonStyleSingleBreasted: {
  "V Neck 4 Button": {
    key: "VNeck4Button",
    img: VestButton4Buttons,
    label: { en: "Button Style", th: "เสื้อกั๊กคอวี 4 กระดุม" },
    showImage: true,
  },
  "V Neck 5 Button": {
    key: "Vneck5Button",
    img: VestButton5Buttons,
    label: { en: "Button Style", th: "เสื้อกั๊กคอวี 5 กระดุม" },
    showImage: true,
  },
  "V Neck 6 Button": {
    key: "Vneck6Button",
    img: VestButton6Buttons,
    label: { en: "Button Style", th: "เสื้อกั๊กคอวี 6 กระดุม" },
    showImage: true,
  },
  "Scooped V as IG 4 Button": {
    key: "ScoopedVIG4Button",
    img: VestButton1ButtonFastened2,
    label: { en: "Button Style", th: "เสื้อกั๊กคอสกู๊ป 4 กระดุม" },
    showImage: true,
  },
  "Scoop Neck 3 Button": {
    key: "ScoopNeck3Button",
    img: VestButton1ButtonFastened,
    label: { en: "Button Style", th: "เสื้อกั๊กคอสกู๊ป 3 กระดุม" },
    showImage: true,
  },
},

    buttonStyleDoubleBreasted: {
  "V Neck DB 6 Button": {
    key: "Vneck6Button",
    img: VestDoubleBreastedsixbuttons,
    label: { en: "Button Style", th: "แบบกระดุม 6 เม็ด คอวี ดับเบิลเบรส" },
    showImage: true,
  },
  "V Neck DB 4 Buttons": {
    key: "VNeckDBFourButtons",
    img: VestDoubleBreasted,
    label: { en: "Button Style", th: "แบบกระดุม 4 เม็ด คอวี ดับเบิลเบรส" },
    showImage: true,
  },
  "V Neck DB 8 Buttons": {
    key: "VNeckDBEightButtons",
    img: VestDoubleBreastedeightbuttons,
    label: { en: "Button Style", th: "แบบกระดุม 8 เม็ด คอวี ดับเบิลเบรส" },
    showImage: true,
  },
  "V Neck Asymmetric 3 Button": {
    key: "VNeckAsymmetricThreeButton",
    img: VestAsymmetric3buttons,
    label: { en: "Button Style", th: "แบบกระดุม 3 เม็ด คอวี แบบไม่สมมาตร" },
    showImage: true,
  },
},

// lapelStyle: {
//   "V Neck": {
//     key: "vNeck",
//     img: LapelStyleVT_NoLapel,
//     label: { en: "Lapel Style", th: "คอวี" },
//     showImage: true,
//   },
//   "Notched Lapel": {
//     key: "notchedLapel",
//     img: LapelStyleVT_NotchedLapel,
//     label: { en: "Lapel Style", th: "ปกเสื้อแบบ Notched" },
//     showImage: true,
//   },
//   "Peak Lapel": {
//     key: "peakLapel",
//     img: LapelStyleVT_PeakLapel,
//     label: { en: "Lapel Style", th: "ปกเสื้อแบบปีกแหลม" },
//     showImage: true,
//   },
//   "Shawl Lapel": {
//     key: "shawlLapel",
//     // img: LapelStyleVT_ShawLapel,
//      img: Shawllapel,
//     label: { en: "Lapel Style", th: "ปกเสื้อแบบผ้าพันไหล่" },
//     showImage: true,
//   },
//   "Fish Mouth": {
//         key: "FishMouth",
//         img: FishMouth,
//         label: { en: "Lapel Style", th: "สไตล์ปกเสื้อ" },
//         showImage: true,
//       },
//   "Trophy Lapel": {
//     key: "trophyLapel",
//     // img: LapelStyleVT_FishMouth,
//     label: { en: "Lapel Style", th: "ปกเสื้อแบบ Trophy" },
//     showImage: true,
//   },
//   "Narrow Lapel": {
//     key: "narrowLapel",
//     img: OvercoatLapeStyleNarrowLapel,
//     label: { en: "Lapel Style", th: "ปกเสื้อแบบแคบ" },
//     showImage: true,
//   },
//   "Wide Lapel": {
//     key: "wideLapel",
//     img: OvercoatLapeStyleWideLapel,
//     label: { en: "Lapel Style", th: "ปกเสื้อแบบกว้าง" },
//     showImage: true,
//   },
//   Classic: {
//     key: "classic",
//     img: OvercoatLapeStyleclassic,
//     label: { en: "Lapel Style", th: "ปกเสื้อแบบคลาสสิก" },
//     showImage: true,
//   },
//   "Stand up": {
//     key: "standUp",
//     img: OvercoatLapeStyleStandup,
//     label: { en: "Lapel Style", th: "ปกเสื้อตั้ง" },
//     showImage: true,
//   },
// },

bottomPocket: {
  "No Pockets": {
    key: "noPockets",
    img: BottomPocketNoPocket2,
    label: { en: "Bottom Pocket", th: "เป๋าล่าง | ไม่มีกระเป๋า |" },
    showImage: true,
  },
  "Regular Pocket": {
    key: "regularPocket",
    img: BottomPocketRegularPocket,
    label: { en: "Bottom Pocket", th: "เป๋าล่าง | กระเป๋าธรรมดา" },
    showImage: true,
  },
  "Pockets with Flaps": {
    key: "pocketsWithFlaps",
    img: BottomPocketFlapsPocket,
    label: { en: "Bottom Pocket", th: "เป๋าล่าง |  กระเป๋ามีฝา" },
    showImage: true,
  },
},

bottomOfVest: {
  "Angled Cut": {
    key: "angledCut",
    img: BottomVT_AngledCut,
    label: { en: "Bottom Of Vest", th: "ชาย | ชายแหลม |" },
    showImage: true,
  },
  "Straight Cut": {
    key: "straightCut",
    img: BottomVT_Straight,
    label: { en: "Bottom Of Vest", th: "ชาย | ชายตรง |" },
    showImage: true,
  },
},

lapelBoutonniere: {
  Normal: {
    key: "normal",
    img: LapelBoutonniereNormal,
    label: { en: "Lapel Boutonniere", th: "รังปก | รังธรรมดา" },
    showImage: true,
  },
  Keyhole: {
    key: "keyhole",
    img: LapelBoutonniereKeyhole,
    label: { en: "Lapel Boutonniere", th: "รังปก |  รังกุญแจ" },
    showImage: true,
  },
  None: {
    key: "none",
    img: "",
    label: { en: "Lapel Boutonniere", th: "รังปก | ไม่มี |" },
    showImage: false,
  },
},

   apaulettes: {
  yes : {
  label: { en: "Apaulettes", th: "บ่าประดับ | ใช่ |" },
  img:ShoulderApaulettes,
  showImage:true,
    },
    No: {
  label: { en: "Apaulettes", th: "บ่าประดับ |ไม่มี |" },
  img:ShoulderApaulettes,
  showImage:true,
    }
 
},
// belt: {
//   label: { en: "Belt", th: "เข็มขัด" },
// },
belt: {
  Loose: {
    key: "belt",
    img: BeltLoose,
    label: {
      en: "Belt",
      th: "เข็มขัดหลวม ($14)"
    },
    showImage: true,
  },
  Sewed: {
    key: "belt",
    img: BeltSewed, 
    label: {
      en: "Belt",
      th: "เย็บในตัว ($14)"
    },
    showImage: true,
  },
},
Buttonholecolour: {
  label: { en: "Buttonhole Colour", th: "สีรางดุม" },
},
CollarStay: {
 Fixed:{
   key: "fixed",
  img: CollarStayImage, // Replace with your actual imported image
  label: { en: "Collar Stay", th: " รองปก | คงที |" },
  showImage: true
 },
 Removable :{
   key: "Removable",
  img: CollarStayImage, // Replace with your actual imported image
  label: { en: "Collar Stay", th: "รองปก | ถอดได้ |" },
  showImage: true
 }


  // key: "CollarStay",
  // img: CollarStayImage, // Replace with your actual imported image
  // label: { en: "Collar Stay", th: "รองปก " },
  // showImage: true
},
// CollarstyleButtonOption: {
//   label: { en: "Collar Style Button Option", th: "ตัวเลือกกระดุมสไตล์ปกเสื้อ" },
// },
numberOfBackPockets: {
  key: "2 Pockets",
  // img: numberOfBackPockets,
  label: { en: "Number of Back Pockets", th: "จำนวนกระเป๋าหลัง" },
  showImage: true
 
},
buttons: {
  label: { en: "Buttons", th: "กระดุม" },
},
suspenderButtons: {
  No: {
    key: "suspenderButtons",
    label: { en: "Suspender Buttons", th: "กระดุมเอี้ยม" },
    showImage: false,
  },
  Yes: {
    key: "suspenderButtons",
    label: { en: "Suspender Buttons", th: "กระดุมเอี้ยม" },
    showImage: false,
  },
},
bandEdgeSystem: {
  Angled: {
    key: "bandEdgeSystem",
    img:BandEdgeAngled,
    label: { en: "Band Edge System", th: "ขอบสามเหลี่ยม | " },
       img: BandEdgeAngled,
    showImage: true,
  },
  Square: {
    key: "bandEdgeSystem",
    img: BandEdgeSquare,
    label: { en: "Band Edge System", th: "ขอบสี่เหลี่ยม |" },
    showImage: true,
  },
  Round: {
    key: "bandEdgeSystem",
    label: { en: "Band Edge System", th: "ขอบมน" },
    showImage: true,
  },
  "Extended Waistband": {
    key: "bandEdgeSystem",
    img: BandEdgeVeryExtendedWaistband,
    label: { en: "Band Edge System", th: "ขอบยืดมากๆ |" },
    showImage: true,
  },
},
btnHoleColor: {
  label: { en: "Button Hole Colour", th: "สีรางดุม" },
},
btnThreadColor: {
  label: { en: "THREAD ON BUTTON", th: "สีด้ายเย็บดุม" },
},
flyOption: {
  Zip: {
    key: "flyOption",
     img: FlyOptionZip,
    label: { en: "Fly Option", th: " แบบเป้ากางเกง | ซิบ |" },
    showImage: true,
  },
  Buttons: {
    key: "flyOption",
    img: FlyOptionButtons,
    label: { en: "Fly Option", th: "ตัวเลือกกระดุมกางเกง" },
    showImage: true,
  },
},
coinPocket: {
  No: {
    key: "coinPocket",
    label: { en: "Coin Pocket", th: "กระเป๋าเหรียญ - ไม่มี" },
    showImage: false,
  },
  Yes: {
    key: "coinPocket",
    label: { en: "Coin Pocket", th: "กระเป๋าเหรียญ - มี" },
    showImage: false,
  },
},
internalWBandColor: {
  Black: {
    key: "internalWBandColor",
    label: { en: "Internal Waistband Colour", th: "สีขอบกางเกง-ด้านใน - ดำ |" },
    showImage: false,
  },
  White: {
    key: "internalWBandColor",
    label: { en: "Internal Waistband Colour", th: "สีขอบกางเกง-ด้านใน - ขาว |" },
    showImage: false,
  },
},
tuxedoSatin: {
  label: { en: "Tuxedo Satin", th: " ซาตินข้างกางเกงทักซิโด้" },
},
remarks: {
  label: { en: "Style Remarks", th: "หมายเหตุเกี่ยวกับสไตล์" },
},
coatStyle: {
  "Single Breasted": {
    key: "coatStyle",
    label: { en: "Coat Style", th: "ดุม 1 แถว |" },
    showImage: false,
  },
  "Double Breasted": {
    key: "coatStyle",
    label: { en: "Coat Style", th: "ดุม 2 แถว |" },
    showImage: false,
  },
},
lapelFelt: {
  label: { en: "Lapel Felt", th: "สีรางดุม |" },
  img:LapelFeltColor,
  showImage: true,
},
shirtButtons: {
  label: { en: "Shirt Buttons", th: "กระดุมเสื้อเชิ้ต" },
},
pocket: {
   "One Pocket": {
    key: "OnePocket",
    label: { en: "Pocket", th: "1 ใบ |" },
    showImage: false,
  },
   "No Pocket": {
    key: "NoPocket",
    label: { en: "Pocket", th: "ไม่มีกระเป๋า |" },
    showImage: false,
  },
  "Two Pockets": {
    key: "TwoPockets",
    label: { en: "Pocket", th: "2 ใบ |" },
    showImage: false,
  },
  // label: { en: "Pocket", th: "กระเป๋า" },
},
monogramPosition: {
  "Left Cuff": {
    key: "monogramPosition",
    label: { en: "Monogram Position", th: "ตำแหน่งปัก | ปักข้อมือซ้าย" },
    showImage: false,
  },
  Pocket: {
    key: "monogramPosition",
    label: { en: "Monogram Position", th: "ตำแหน่งปักอักษร - กระเป๋า" },
    showImage: false,
  },
},
LiningAtBack: {
  No: {
    key: "monogramPosition",
    label: { en: "Lining at Back", th: "ซับในด้านหลัง - ไม่มี" },
    showImage: false,
  },
  Yes: {
    key: "monogramPosition",
    label: { en: "Lining at Back", th: "ซับในด้านหลัง - มี" },
    showImage: false,
  },
},
vestButton: {
  label: { en: "Vest Button", th: "กระดุมเสื้อกั๊ก" },
},
buttonNumber: {
  label: { en: "Button Number", th: "จำนวนกระดุม" },
},
satinColour: {
  label: { en: "Satin Colour", th: "สีผ้าซาติน" },
},

  };

  if (styles[styleName]) {
    return styles[styleName];
  } else {
    return false;
  }
};

export default productStyleAttributes;
